(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["moment-mark"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('moment-mark')) {
    // Touch devices have no hover, so each mark plays its gesture once when it scrolls into view.
    class MomentMark extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        if (!('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.setAttribute('data-played', '');
            this.timer = window.setTimeout(() => this.removeAttribute('data-played'), 900);
          },
          { threshold: 0.6 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        window.clearTimeout(this.timer);
      }
    }

    customElements.define('moment-mark', MomentMark);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["moments-about-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('moments-about-menu')) {
    class MomentsAboutMenu extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.m-about-menu__trigger');
        this.panel = this.querySelector('.m-about-menu__panel');
        if (!this.trigger || !this.panel) return;
        this.ac = new AbortController();
        const o = { signal: this.ac.signal };
        this.trigger.addEventListener('click', () => { if (this.hovered) { this.hovered = false; return; } this.toggle(); }, o);
        this.trigger.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown') { e.preventDefault(); this.open(); this.links()[0]?.focus(); }
        }, o);
        this.panel.addEventListener('keydown', (e) => this.onPanelKey(e), o);
        this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.close(); }, o);
        document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.close(); }, o);
        this.hoverMq = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse' && this.hoverMq.matches) { clearTimeout(this.timer); if (this.panel.hidden) this.hovered = true; this.open(); } }, o);
        this.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse' && this.hoverMq.matches) { clearTimeout(this.timer); this.timer = setTimeout(() => { this.hovered = false; this.close(); }, 250); } }, o);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.ac) this.ac.abort();
      }

      links() {
        return [...this.panel.querySelectorAll('a')];
      }

      open() {
        this.panel.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
      }

      close() {
        if (this.panel.hidden) return;
        this.panel.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
      }

      toggle() {
        if (this.panel.hidden) this.open(); else this.close();
      }

      onPanelKey(e) {
        const list = this.links();
        const i = list.indexOf(document.activeElement);
        if (e.key === 'Escape') { e.preventDefault(); this.close(); this.trigger.focus(); }
        else if (e.key === 'ArrowDown') { e.preventDefault(); list[Math.min(list.length - 1, i + 1)]?.focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); if (i <= 0) this.trigger.focus(); else list[i - 1].focus(); }
      }
    }

    customElements.define('moments-about-menu', MomentsAboutMenu);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["moments-carousel-controls"] && !Shopify.designMode) return;
  try {
    (() => {
    const labels = () => { const t = document.querySelector('[data-m-carousel-labels]'); return t ? t.dataset : { prev: 'Previous', next: 'Next' }; };
    const chevron = '<svg class="m-chevron" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M5 2l5 5-5 5"/></svg>';

    function setup(section) {
      if (section.dataset.mCarousel) return;
      const slides = section.querySelector('slideshow-slides');
      const header = section.querySelector('.section-resource-list__header .layout-panel-flex');
      const link = header && header.querySelector('a');
      if (!slides || !header || !link) return;
      section.dataset.mCarousel = 'true';

      const end = document.createElement('div');
      end.className = 'm-carousel-end';
      link.replaceWith(end);
      end.appendChild(link);
      const controls = document.createElement('div');
      controls.className = 'm-carousel-controls';
      controls.setAttribute('role', 'group');
      const make = (dir, text) => { const b = document.createElement('button'); b.type = 'button'; b.dataset.dir = dir; b.setAttribute('aria-label', text); b.innerHTML = chevron; return b; };
      const prev = make('prev', labels().prev);
      const next = make('next', labels().next);
      controls.append(prev, next);
      end.appendChild(controls);

      const rtl = () => getComputedStyle(slides).direction === 'rtl';
      const card = () => slides.querySelector('slideshow-slide.resource-list__slide');
      const step = () => { const c = card(); const gap = parseFloat(getComputedStyle(slides).columnGap) || 0; return (c ? c.getBoundingClientRect().width : slides.clientWidth * 0.8) + gap; };
      const go = (dir) => slides.scrollBy({ left: dir * (rtl() ? -1 : 1) * step(), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      prev.addEventListener('click', () => go(-1));
      next.addEventListener('click', () => go(1));

      let raf = 0;
      const update = () => {
        raf = 0;
        const pos = Math.abs(slides.scrollLeft);
        prev.disabled = pos < 2;
        next.disabled = pos + slides.clientWidth >= slides.scrollWidth - 2;
      };
      slides.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    const run = () => document.querySelectorAll('.section-resource-list').forEach(setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    window.addEventListener('load', run);
    document.addEventListener('shopify:section:load', run);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["moments-language-toggle"] && !Shopify.designMode) return;
  try {
    // Every language switch returns to the page the visitor is on, never to a Section Rendering URL (?section_id= / ?sections=)
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || new URL(form.action, location.href).pathname !== '/localization') return;
      const returnTo = form.querySelector('input[name="return_to"]');
      if (!returnTo) return;
      const page = new URL(location.href);
      page.searchParams.delete('section_id');
      page.searchParams.delete('sections');
      returnTo.value = page.pathname + page.search;
    },
    true
  );
  } catch(e) { console.error(e); }
})();

})();
